/* Saved pieces drawer -- behaviour. Markup in snippets/saved-drawer.liquid,
   styles in assets/saved-drawer.css.
 *
 * THE LIST IS A SNAPSHOT, NOT A POINTER. Saving writes the handle, title, price,
 * image and available variants at the moment the heart is pressed, under
 * `sujatra:saved:meta`, beside the id array `sujatra:saved` that product-wish and
 * card-craft already share. So the drawer opens with no request and nothing to
 * wait for, and still works when the shop is slow.
 */
(function () {
  'use strict';

  var IDS = 'sujatra:saved';
  var META = 'sujatra:saved:meta';

  function ids() {
    try { return JSON.parse(localStorage.getItem(IDS)) || []; } catch (e) { return []; }
  }
  function meta() {
    try { return JSON.parse(localStorage.getItem(META)) || {}; } catch (e) { return {}; }
  }
  function writeIds(list) {
    try { localStorage.setItem(IDS, JSON.stringify(list.slice(-200))); } catch (e) {}
  }
  function writeMeta(m) {
    try { localStorage.setItem(META, JSON.stringify(m)); } catch (e) {}
  }

  var drawer = document.getElementById('saved');
  var list = drawer && drawer.querySelector('[data-sjsv-list]');
  var countEl = null;

  function open(on) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', on);
    drawer.setAttribute('aria-hidden', on ? 'false' : 'true');
    /* The same lock every drawer in this theme uses, so two cannot both think
       they own the scroll position. */
    document.body.classList.toggle('overflow-hidden', on);
    if (on) render();
  }

  function paintCount() {
    if (!countEl) return;
    var n = ids().length;
    /* Empty, not hidden: .cart-count-bubble:empty is how the theme's own badge
       disappears, so an empty string is the correct "nothing saved". */
    countEl.textContent = n ? (n > 99 ? '99+' : String(n)) : '';
  }

  function remove(id) {
    var l = ids();
    var at = l.indexOf(id);
    if (at !== -1) { l.splice(at, 1); writeIds(l); }
    var m = meta();
    delete m[id];
    writeMeta(m);
    /* Unpaint every heart for this piece, wherever it is on the page, so the
       drawer and the grid behind it never disagree. */
    document.querySelectorAll('.cc-wish[data-wish-id="' + id + '"], [data-product-wish="' + id + '"]')
      .forEach(function (b) {
        b.classList.remove('cc-wish--on', 'pwish--on');
        b.setAttribute('aria-pressed', 'false');
      });
    paintCount();
    render();
  }

  /* An empty list is a snapshot problem, not a stock fact: Sujatra sells on
     CONTINUE, so the row must never turn this into a claim either way. */
  function variantsOf(d) {
    try { return JSON.parse(d.vs || '[]') || []; } catch (e) { return []; }
  }

  /*
   * A ROW REPAIRS ITSELF RATHER THAN DEAD-ENDING.
   *
   * Snapshots saved before 4 Oct 2026 carry no variants, so those rows had
   * nothing to size and nothing to buy -- which is what Bed saw: "where did add
   * to cart go". Re-saving would fix it, but nobody should have to re-save a list
   * they already made. So a row with no variants fetches them once, writes them
   * back into the snapshot and re-renders with its size picker.
   *
   * Only the old rows pay for it; a fresh save already carries its variants. The
   * guard makes it once per piece per page, so a render triggered by the repair
   * cannot start the repair again.
   */
  var repairing = {};
  function repair(id, handle) {
    if (!handle || repairing[id]) return;
    repairing[id] = true;
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.variants) return;
        var vs = [];
        p.variants.forEach(function (v) {
          if (v.available) vs.push({ i: v.id, t: v.title });
        });
        if (!vs.length) return;
        var m = meta();
        m[id] = m[id] || {};
        m[id].vs = JSON.stringify(vs);
        if (!m[id].t) m[id].t = p.title;
        if (!m[id].h) m[id].h = handle;
        writeMeta(m);
        render();
      })
      .catch(function () { /* offline, or the piece is gone: the row keeps View */ });
  }

  function addToBag(row, variantId) {
    if (!variantId) return;
    var btn = row.querySelector('.sjsv__bag');
    btn.disabled = true;
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    }).then(function (r) {
      btn.textContent = r.ok ? 'Added' : 'Try again';
      if (r.ok) document.dispatchEvent(new CustomEvent('sjsv:added'));
      else btn.disabled = false;
    }).catch(function () {
      btn.textContent = 'Try again';
      btn.disabled = false;
    });
  }

  function render() {
    if (!list) return;
    var all = ids();
    var m = meta();
    while (list.firstChild) list.removeChild(list.firstChild);

    var nEl = drawer.querySelector('[data-sjsv-n]');
    if (nEl) nEl.textContent = all.length ? '(' + all.length + ')' : '';

    if (!all.length) {
      var none = document.createElement('li');
      none.className = 'sjsv__empty';
      none.textContent = 'Nothing saved yet. Tap the heart on a piece you like.';
      list.appendChild(none);
      return;
    }

    /* Newest first: the list is appended to, so the last saved is the one they
       are most likely to be looking for. */
    all.slice().reverse().forEach(function (id) {
      var d = m[id] || {};
      var li = document.createElement('li');
      li.className = 'sjsv__row';

      var a = document.createElement('a');
      a.href = d.h ? '/products/' + d.h : '#';
      a.setAttribute('aria-label', d.t || 'Saved piece');

      if (d.i) {
        var img = document.createElement('img');
        img.src = d.i;
        img.alt = d.t || '';
        img.loading = 'lazy';
        a.appendChild(img);
      } else {
        /* Saved with no image: a grey block rather than a broken picture. */
        var ph = document.createElement('span');
        ph.className = 'sjsv__ph';
        a.appendChild(ph);
      }
      li.appendChild(a);

      var mid = document.createElement('div');
      var name = document.createElement('a');
      name.className = 'sjsv__name';
      name.href = a.href;
      name.textContent = d.t || 'View this piece';
      mid.appendChild(name);
      if (d.p) {
        var pr = document.createElement('div');
        pr.className = 'sjsv__price';
        pr.textContent = d.p;
        mid.appendChild(pr);
      }
      li.appendChild(mid);

      var acts = document.createElement('div');
      acts.className = 'sjsv__acts';
      mid.appendChild(acts);

      /*
       * SIZE IS ASKED FOR, NEVER ASSUMED. Bed, 4 Oct 2026: "for sized variants
       * give option to add to cart and give option to pick size". One variant
       * goes straight in; several and the drawer asks -- and it asks with an
       * UNSELECTED placeholder, because a select pre-set to its first option is
       * not a question. The first option is XS, so the default would have put
       * the smallest size in the bag of anyone who did not look.
       */
      var vs = variantsOf(d);
      var pick = null;
      if (vs.length > 1) {
        pick = document.createElement('select');
        pick.className = 'sjsv__size';
        pick.setAttribute('aria-label', 'Size');
        var ask = document.createElement('option');
        ask.value = '';
        ask.textContent = 'Size';
        pick.appendChild(ask);
        vs.forEach(function (v) {
          var o = document.createElement('option');
          o.value = v.i;
          o.textContent = v.t;
          pick.appendChild(o);
        });
        acts.appendChild(pick);
      }

      if (vs.length) {
        var bag = document.createElement('button');
        bag.className = 'sjsv__bag';
        bag.type = 'button';
        /* "Add to cart", the product page's own words. It said "Add to bag",
           which is a second name for the same act on the same site. Bed, 4 Oct
           2026: "change add to bag to add to cart". */
        bag.textContent = 'Add to cart';
        bag.addEventListener('click', function () {
          var v = pick ? pick.value : vs[0].i;
          if (!v) { pick.focus(); return; }
          addToBag(li, v);
        });
        acts.appendChild(bag);
      } else {
        /* No variants yet. The product page is offered while repair() goes and
           gets them -- never a stock verdict, which CONTINUE makes unsupportable. */
        var view = document.createElement('a');
        view.className = 'sjsv__bag';
        view.href = a.href;
        view.textContent = 'View';
        acts.appendChild(view);
        repair(id, d.h);
      }

      var drop = document.createElement('button');
      drop.className = 'sjsv__drop';
      drop.type = 'button';
      drop.textContent = 'Remove';
      drop.addEventListener('click', function () { remove(id); });
      acts.appendChild(drop);

      list.appendChild(li);
    });
  }

  /* The heart in the header, injected because sections/header.liquid is 36,852
     bytes and cannot be pushed through the API at all -- see the snippet's doc. */
  function mountHeader() {
    try {
      var cart = document.getElementById('cart-icon-bubble');
      if (!cart || document.querySelector('.sjsv-link')) return;
      var a = document.createElement('a');
      a.href = '#saved';
      a.className = 'header__icon link focus-inset sjsv-link';
      a.setAttribute('aria-label', 'Saved pieces');
      a.innerHTML =
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"'
        + ' stroke-linecap="round" stroke-linejoin="round" width="20" height="20" aria-hidden="true">'
        + '<path d="M12 20.2 4.6 13a4.6 4.6 0 0 1 6.5-6.5l.9.9.9-.9A4.6 4.6 0 1 1 19.4 13z"/></svg>'
        + '<div class="cart-count-bubble sjsv-count"></div>';
      a.addEventListener('click', function (e) { e.preventDefault(); open(true); });
      cart.parentNode.insertBefore(a, cart);
      countEl = a.querySelector('.sjsv-count');
      paintCount();
    } catch (e) { /* a heart must never break the header */ }
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-sjsv-close]')) { open(false); return; }
    /* Any heart anywhere changes the count, without each writer needing to know
       this drawer exists. */
    if (e.target.closest('.cc-wish, [data-product-wish]')) {
      window.setTimeout(paintCount, 0);
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) open(false);
  });

  function boot() {
    mountHeader();
    if (window.location.hash === '#saved') open(true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();